export default __webpack_public_path__ + "static/media/cyborg.d9aca880.png";